import { Inject, Injectable } from '@angular/core';
import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';
import { DocumentSendEmailMultiCommand, DocumentSendEmailMultiCommandHandlerBase, DocumentSendEmailSingleCommand, DocumentSendEmailSingleCommandHandlerBase } from '@skylab-shared/business';
import { HttpService } from '@skylab-shared/core';

@CommandHandlerFor(DocumentSendEmailSingleCommand)
@Injectable({ providedIn: 'root'})
export class DocumentSendEmailSingleCommandHandler {
    private commandHandler: DocumentSendEmailSingleCommandHandlerBase;

    public constructor(
        @Inject(Http) http: HttpService
    ) {
        this.commandHandler = new DocumentSendEmailSingleCommandHandlerBase(http);
    }

    public async handleAsync(params: DocumentSendEmailSingleCommand): Promise<void> {
        await this.commandHandler.handleAsync(params);
    }
}

@CommandHandlerFor(DocumentSendEmailMultiCommand)
@Injectable({ providedIn: 'root'})
export class DocumentSendEmailMultiCommandHandler {
    private commandHandler: DocumentSendEmailMultiCommandHandlerBase;

    public constructor(
        @Inject(Http) http: HttpService
    ) {
        this.commandHandler = new DocumentSendEmailMultiCommandHandlerBase(http);
    }

    public async handleAsync(params: DocumentSendEmailMultiCommand): Promise<void> {
        await this.commandHandler.handleAsync(params);
    }
}
